import React, { useEffect, useState } from 'react'

import { deleteAttachment, loadAndUpdateVideoInfo } from '../../../../../../../../redux/thunks/multimedia/multimedia'
import { useAppDispatch, useAppSelector } from '../../../../../../../../app/hooks'

import { Attachment, AttachmentType, StreamingVideoUrl } from '../../../../../../../../@types/types'

import commonStyles from '../AttachmentsList.module.css'
import { useDisableBodyScroll } from '../../../../../../../common/hooks/useDisableBodyScroll'
import VideoControlButtons from './videoControlButtons/VideoControlButtons'
import VideoPreviewModal from './previewModal/VideoPreviewModal'
import VideoThumbnail from './thumbnail/VideoThumbnail'

const EMPTY_VIDEO_SOURCE_URLS: StreamingVideoUrl[] = []

export const Video: React.FC<{
  videoAttachment: Attachment
}> = ({ videoAttachment }) => {
  const dispatch = useAppDispatch()
  const [previewOpened, setPreviewOpened] = useState(false)
  const closePreview = () => setPreviewOpened(false)
  const handlePlayIconClick = () => setPreviewOpened(true)
  const handleTrashIconClick = async () => {
    await dispatch(deleteAttachment(videoAttachment.id, videoAttachment.source, videoAttachment.size, true))
  }

  useDisableBodyScroll(previewOpened)

  const videoInfos = useAppSelector((state) => state.multimediaFeature.videoInfo)
  const videoInfo = videoInfos[0]
  const videoInfoSourceUrls = videoInfo?.videoInfo?.videoUrlList ?? EMPTY_VIDEO_SOURCE_URLS
  const videoInfoSourceTeaserUrl = videoInfo?.videoInfo?.teaserUrl
  const videoAttachmentData = useAppSelector((state) =>
    state.multimediaFeature.attachments.find((it) => it.attachment?.type === AttachmentType.VIDEO)
  )
  const offerApiId = videoAttachmentData?.attachment?.offerApiId
  const realEstateId = useAppSelector((state) => state.insertionFeature.insertionIdentification.realEstateId)

  useEffect(() => {
    const offerApiIdSelected = offerApiId || videoAttachment.offerApiId
    if (realEstateId && offerApiIdSelected) {
      dispatch(loadAndUpdateVideoInfo(realEstateId, offerApiIdSelected))
    }
  }, [dispatch, offerApiId, realEstateId, videoAttachment.offerApiId])

  const videoSourceWhenUploading = videoInfos.find((videoInfo) => videoInfo.videoId === videoAttachment.videoId)

  return (
    <div className='grid-item one-half'>
      <div className={`${commonStyles.attachmentContainer} align-center border-radius-rounded`}>
        <VideoThumbnail
          data-testid={'video-thumbnail'}
          ariaLabel={videoAttachment.title}
          videoInfoSourceTeaserUrl={videoInfoSourceTeaserUrl}
          videoSourceWhenUploading={videoSourceWhenUploading}
          videoInfoSourceUrls={videoInfoSourceUrls}
        />
        <VideoPreviewModal visible={previewOpened} onClick={closePreview} videoInfoSourceUrls={videoInfoSourceUrls} />
        <VideoControlButtons onPreviewClick={handlePlayIconClick} onDeleteClick={handleTrashIconClick} />
      </div>
    </div>
  )
}

export default Video
